module.exports = __webpack_public_path__ + "static/media/amazon_logo_login.abc51cc8.png";